import React, { useState } from 'react'
import Button from '../../shared/Button'
import {ReactComponent as EditTitle} from "../../../assets/img/editresidenceicon/text-block.svg";
import {ReactComponent as EditAvatar} from "../../../assets/img/editresidenceicon/gallery.svg";
import {ReactComponent as EditCapacity} from "../../../assets/img/editresidenceicon/house-2.svg";
import {ReactComponent as EditClock} from "../../../assets/img/editresidenceicon/clock.svg";
import {ReactComponent as EditFeature} from "../../../assets/img/editresidenceicon/document-filter.svg";
import {ReactComponent as EditPrice} from "../../../assets/img/editresidenceicon/calendar-circle.svg";
import {ReactComponent as EditlessTime} from "../../../assets/img/editresidenceicon/calendar.svg";
import { Switch } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
const EditResidenceSideBar = ({setdiscountModal,setcostModal}) => {
  const array  = [
    {
      title:"ویرایش عنوان اقامتگاه",
      icon:<EditTitle/>,
      step:2,
      substep:1,
      modal:false
    },
    {
      title:"ویرایش عکس نمایه",
      icon:<EditAvatar/>,
      modal:false,
      step:9,
      substep:1,
    },
    {
      title:"ویرایش ظرفیت اقامتگاه",
      icon:<EditCapacity/>,
      step:4,
      modal:false,
      substep:1,

    },
    {
      title:"ویرایش ساعت ورود و خروج",
      icon:<EditClock/>,
      step:7,
      substep:1,
      modal:false
    },
    {
      title:"ویرایش امکانات رفاهی",
      icon:<EditFeature/>,
      step:6,
      substep:1,

      modal:false
    },
    
  
    {
      title:"ویرایش حداقل مدت اقامت",
      icon:<EditlessTime/>,
      step:7,
      substep:1,
      modal:false
    },
    {
      title:"قیمت گذاری بر اساس تاریخ",
      icon:<EditPrice />,
      func:()=>setcostModal(true),
      modal:true
    },
  
  ]
  const [instant, setinstant] = useState(false)
  const {id}=useParams()
  const onChange = (checked) => {
    setinstant(checked);
   };
   const navigate = useNavigate()
   const gotoEdit=(step,modal,substep,func)=>{
if(!modal){
  navigate(`/create/${id}/${step}/${substep}`)
}else{
  func()
}
   }
  return (
    <div className='EditResidenceSideBar'>
      <div className='EditResidenceSideBar--title'>
      برگشت و بستن
      </div>
      <div >
      {array.map(i=><Button onClick={()=>gotoEdit(i.step,i.modal,i.substep,i.func)} fullwidth={true} className='mb-[10px]' varient="outline-gray"> <div className='flex gap-[18px] items-center justify-around whitespace-nowrap'>
       {i.icon}  <div>{i.title}</div></div> </Button>)}
      </div>
      <div>
        <h3>تحویل فوری</h3>
        <p>درخواست رزرو  بدون پاسخ میزبان تایید میشود .</p>
      <div className='Modal_Switch'>
     <Switch defaultChecked onChange={onChange} checked={instant}/>
     </div>
      </div>
      <div>
        <h3>تخفیف ویژه</h3>
        <p>می توانید برای روز های خاصی در ماه یا به مناسبت های  در سال تخفیف ویژه برای رزرو ایجاد کنید</p>
        <Button varient="fifth" onClick={()=>setdiscountModal(true)} fullwidth>اعمال تاریخ تخفیف</Button>
      </div>
      
    </div>
  )
}

export default EditResidenceSideBar